<div v-if="!loginDone">Autenticando...</div>